import React from "react";
import { withTranslation } from "react-i18next";
import { getWindow } from "ssr-window";
import url from "@/utils/url";

class ToolbarSection extends React.Component {
  // 戻る
  backClick = () => {
    const {
      router: {
        history: { goBack, replace },
      },
    } = this.props;
    if (getWindow()?.history?.state?.referrer) {
      goBack();
    } else {
      replace(url.home);
    }
  };

  render() {
    return (
      <div className="single-menu-bar">
        <div className="single-menu-bar-inner">
          <div className="back-button">
            <div
              onClick={this.backClick}
              className="back-button-inner"
              tabIndex="0"
            >
              <span>{this.props.t("TWBC0001_back")}</span>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default withTranslation()(ToolbarSection);
